// extracted by mini-css-extract-plugin
module.exports = {"currency__wrapper":"elements_currency__wrapper__3P1s5","little__circle":"elements_little__circle__3JBI0","btg":"elements_btg__4tq8d"};